const getClientLoginBackgroundImage = (client) => {
  const clientBackground = client?.assets.find(asset => asset.type.type === 'login-parent-background')
  return clientBackground ? clientBackground.filename : null  
}

export default getClientLoginBackgroundImage